import TrendIndicator from './TrendIndicator';
export default TrendIndicator;
